import React from 'react';
import styled from '@emotion/styled';
import LogoWithText from '../design-system/icons/js/LogoWithText';

const Logo = ({scale = 1.0}) => (
    <StyledLogo scale={scale}>
        <LogoWithText/>
    </StyledLogo>
);

const StyledLogo = styled('div')`
    display: inline-flex;
    align-items: center;

    > svg {
        width: ${props => props.scale * 102}px;
        height: ${props => props.scale * 43}px;
        margin-right: 2px;
    }
`;

export default Logo;
